module.exports = __webpack_public_path__ + "img/0xF35262a9d427F96d2437379eF090db986eaE5d42.4b59536f.png";